import { createMemoryHistory, createRouter } from 'vue-router'
import ScreenOne from '../views/ScreenOne.vue'
import ScreenZeroZero from '../views/ScreenZeroZero.vue'


const routes = [
  {
    path: '/',
    name: 'screen-zero-zero',
    component: ScreenZeroZero
  },
  {
    path: '/anim-one',
    name: 'anim-one',
    component: () => import('../views/AnimOne.vue')
  },

  {
    path: '/screen-one',
    name: 'screen-one',
    component: ScreenOne
  },
  {
    path: '/anim-two',
    name: 'anim-two',
    component: () => import('../views/AnimTwo.vue')
  },
  {
    path: '/screen-two-new-new',
    name: 'screen-two-new-new',
    component: () => import('../views/ScreenTwoNewNew.vue')
  },
  {
    path: '/screen-three',
    name: 'screen-three',
    component: () => import('../views/ScreenThree.vue')
  },
  {
    path: '/anim-three',
    name: 'anim-three',
    component: () => import('../views/AnimThree.vue')
  },
  {
    path: '/screen-four',
    name: 'screen-four',
    component: () => import('../views/ScreenFour.vue')
  },
  {
    path: '/screen-two',
    name: 'screen-two',
    component: () => import('../views/ScreenTwoNew.vue')
  },
  {
    path: '/completion',
    name: "CongratulationsPage",
    component: () => import('../views/CongratulationsPage.vue')
  }
]

const router = createRouter({
  history: createMemoryHistory(),
  routes
})

export default router
